export const programacionBus = 1;

export const ModuloHelper = {
    programacionBus,
};